module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fire-extinguisher/label-image.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fire-extinguisher/label-image.png
// module id = 563
// module chunks = 0